// extracted by mini-css-extract-plugin
export default {"small":"Scoreboard_small__BMryt","statRow":"Scoreboard_statRow__WlUis","scoreTable":"Scoreboard_scoreTable__U8Vvm"};